import React from 'react';
import styled from 'styled-components';

const AddStepButton = ({ onAdd, disabled }) => {
  return (
    <Container>
      <ConnectorLine />
      <AddButton 
        onClick={onAdd} 
        disabled={disabled}
        title={disabled ? "Maximum 10 emails allowed in sequence" : "Add next email in sequence"}
      >
        <PlusIcon>+</PlusIcon>
      </AddButton>
    </Container>
  );
};

export default AddStepButton;

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 5px 0 15px;
`;

const ConnectorLine = styled.div`
  width: 2px;
  height: 40px;
  background-color: #ccc;
`;

const AddButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${props => props.disabled ? '#e0e0e0' : '#2196f3'};
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s;
  margin-top: -1px; /* Connect to the line */
  
  &:hover {
    background-color: ${props => props.disabled ? '#e0e0e0' : '#1976d2'};
    transform: ${props => props.disabled ? 'none' : 'scale(1.1)'};
  }
`;

const PlusIcon = styled.span`
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
`; 